import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_clipboard_7bd1d370 from 'nuxt_plugin_clipboard_7bd1d370' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_libplugin484ad81c_325ce1f5 from 'nuxt_plugin_libplugin484ad81c_325ce1f5' // Source: ./lib.plugin.484ad81c.js (mode: 'client')
import nuxt_plugin_vlazyload_778d35d6 from 'nuxt_plugin_vlazyload_778d35d6' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_70df7ff4 from 'nuxt_plugin_nuxtsvgsprite_70df7ff4' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_axios_7d003230 from 'nuxt_plugin_axios_7d003230' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginrouting_5b48f8de from 'nuxt_plugin_pluginrouting_5b48f8de' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6997cf51 from 'nuxt_plugin_pluginmain_6997cf51' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_libplugin3cadf840_5758c74b from 'nuxt_plugin_libplugin3cadf840_5758c74b' // Source: ./lib.plugin.3cadf840.js (mode: 'all')
import nuxt_plugin_gromMethods_d89c0238 from 'nuxt_plugin_gromMethods_d89c0238' // Source: ../plugins/gromMethods.js (mode: 'all')
import nuxt_plugin_logger_057b83b1 from 'nuxt_plugin_logger_057b83b1' // Source: ../plugins/logger.js (mode: 'all')
import nuxt_plugin_initScript_56865266 from 'nuxt_plugin_initScript_56865266' // Source: ../plugins/initScript.js (mode: 'client')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_img_5d5adb6c from 'nuxt_plugin_img_5d5adb6c' // Source: ../plugins/img.js (mode: 'all')
import nuxt_plugin_vbodyscrolllock_0f4d282c from 'nuxt_plugin_vbodyscrolllock_0f4d282c' // Source: ../plugins/v-body-scroll-lock.js (mode: 'client')
import nuxt_plugin_infiniteloading_68d2fb1c from 'nuxt_plugin_infiniteloading_68d2fb1c' // Source: ../plugins/infiniteloading (mode: 'client')
import nuxt_plugin_vtouch_036385c5 from 'nuxt_plugin_vtouch_036385c5' // Source: ../plugins/v-touch.js (mode: 'client')
import nuxt_plugin_ymapPlugin_43baa32b from 'nuxt_plugin_ymapPlugin_43baa32b' // Source: ../plugins/ymapPlugin.js (mode: 'client')
import nuxt_plugin_vClickOutside_77337246 from 'nuxt_plugin_vClickOutside_77337246' // Source: ../plugins/vClickOutside (mode: 'client')
import nuxt_plugin_vuedadata_a85a809a from 'nuxt_plugin_vuedadata_a85a809a' // Source: ../plugins/vue-dadata.js (mode: 'client')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_commonMetrics_4317ea15 from 'nuxt_plugin_commonMetrics_4317ea15' // Source: ../plugins/commonMetrics.js (mode: 'client')
import nuxt_plugin_vuemoment_732aa8ba from 'nuxt_plugin_vuemoment_732aa8ba' // Source: ../plugins/vue-moment.js (mode: 'client')
import nuxt_plugin_vuefilterpluralize_4a7429df from 'nuxt_plugin_vuefilterpluralize_4a7429df' // Source: ../plugins/vue-filter-pluralize.js (mode: 'all')
import nuxt_plugin_vueperfectscrollbar_4f61232e from 'nuxt_plugin_vueperfectscrollbar_4f61232e' // Source: ../plugins/vue-perfect-scrollbar.js (mode: 'all')
import nuxt_plugin_vueawesomecountdownclient_ad4e9730 from 'nuxt_plugin_vueawesomecountdownclient_ad4e9730' // Source: ../plugins/vue-awesome-countdown.client.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'client')
import nuxt_plugin_swiperclient_d2033868 from 'nuxt_plugin_swiperclient_d2033868' // Source: ../plugins/swiper.client.js (mode: 'client')
import nuxt_plugin_retailCRMclient_3a305a7a from 'nuxt_plugin_retailCRMclient_3a305a7a' // Source: ../plugins/retailCRM.client.js (mode: 'client')
import nuxt_plugin_vuesimpleportal_a4e234e6 from 'nuxt_plugin_vuesimpleportal_a4e234e6' // Source: ../plugins/vue-simple-portal.js (mode: 'client')
import nuxt_plugin_wishlistSync_beb52c7e from 'nuxt_plugin_wishlistSync_beb52c7e' // Source: ../plugins/wishlistSync.js (mode: 'client')
import nuxt_plugin_utm_339bcf02 from 'nuxt_plugin_utm_339bcf02' // Source: ../plugins/utm.js (mode: 'client')
import nuxt_plugin_auth_f4517570 from 'nuxt_plugin_auth_f4517570' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"fade-in-left","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru"},"title":"p.p.s. - официальный интернет-магазин","meta":[{"charset":"utf-8"},{"name":"Content-Security-Policy","content":"default-src *; style-src 'self' 'unsafe-inline'; script-src 'self' 'unsafe-inline' 'unsafe-eval' https:\u002F\u002Fapi.v4.post-post-scriptum.com\u002F"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no, minimal-ui"},{"name":"yandex-verification","content":"23b2b65a353e4f24"},{"name":"google-site-verification","content":"hEFjtwdCq6t3NBqu14TociyCx3LniyX8QwDQt_PsuKc"},{"name":"google-site-verification","content":"r4i90WLwF7lVyfR7JCfGFsZqFTw6Qrx1LfSpoMzGf6I"},{"hid":"description","name":"description","content":"PPS предлагает большой выбор образов  для самовыражения. Мы создаём одежду, которая не мешает быть собой и оставляет место для твоего собственного высказывания. Наш телефон в Москве: +7 (499) 229-11-11"},{"hid":"og:description","property":"og:description","content":"PPS предлагает большой выбор образов  для самовыражения. Мы создаём одежду, которая не мешает быть собой и оставляет место для твоего собственного высказывания. Наш телефон в Москве: +7 (499) 229-11-11"},{"hid":"og:site_name","property":"og:site_name","content":"Post Post Scriptum"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"PPS"},{"hid":"og:image","property":"og:image","content":"\u002Fog-image.jpg"},{"hid":"og:image:height","property":"og:image:height","content":"320"},{"hid":"og:image:width","property":"og:image:width","content":"320"},{"name":"msapplication-TileColor","content":"#ff002a"},{"name":"theme-color","content":"#fff"}],"link":[{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"shortcut icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"mage\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"\u002Ffavicon-96x96.png"},{"rel":"preconnect","href":"https:\u002F\u002Fi.post-post-scriptum.com"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.v4.post-post-scriptum.com\u002F"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.diginetica.net\u002F"},{"rel":"preconnect","href":"https:\u002F\u002Ftracking.diginetica.net\u002F"},{"rel":"preconnect","href":"https:\u002F\u002Ftracking-app.diginetica.net\u002F"}],"script":[{"src":"\u002Fjs\u002Fevercookie.js","type":"text\u002Fjavascript"},{"innerHTML":"(function(w, d, s, h, id) {\n                w.roistatProjectId = id; w.roistatHost = h;\n                var p = d.location.protocol == \"https:\" ? \"https:\u002F\u002F\" : \"http:\u002F\u002F\";\n                var u = \u002F^.*roistat_visit=[^;]+(.*)?$\u002F.test(d.cookie) ? \"\u002Fdist\u002Fmodule.js\" : \"\u002Fapi\u002Fsite\u002F1.0\u002F\"+id+\"\u002Finit?referrer=\"+encodeURIComponent(d.location.href);\n                var js = d.createElement(s); js.charset=\"UTF-8\"; js.async = 1; js.src = p+h+u; var js2 = d.getElementsByTagName(s)[0]; js2.parentNode.insertBefore(js, js2);\n            })(window, document, 'script', 'cloud.roistat.com', 'e05a0b2c36f1a8922e2c0cf73615d2ba');","body":true,"type":"text\u002Fjavascript","charset":"utf-8"},{"innerHTML":"(function() {\n                    if (window.roistat !== undefined) {\n                        handler();\n                    } else {\n                        var pastCallback = typeof window.onRoistatAllModulesLoaded === \"function\" ? window.onRoistatAllModulesLoaded : null;\n                        window.onRoistatAllModulesLoaded = function () {\n                            if (pastCallback !== null) {\n                                pastCallback();\n                            }\n                            handler();\n                        };\n                    }\n\n                    function handler() {\n                        function init() {\n                            appendMessageToLinks();\n\n                            var delays = [1000, 5000, 15000];\n                            setTimeout(function func(i) {\n                                if (i === undefined) {\n                                    i = 0;\n                                }\n                                appendMessageToLinks();\n                                i++;\n                                if (typeof delays[i] !== 'undefined') {\n                                    setTimeout(func, delays[i], i);\n                                }\n                            }, delays[0]);\n                        }\n\n                        function replaceQueryParam(url, param, value) {\n                            var explodedUrl = url.split('?');\n                            var baseUrl = explodedUrl[0] || '';\n                            var query = '?' + (explodedUrl[1] || '');\n                            var regex = new RegExp(\"([?;&])\" + param + \"[^&;]*[;&]?\");\n                            var queryWithoutParameter = query.replace(regex, \"$1\").replace(\u002F&$\u002F, '');\n                            return baseUrl + (queryWithoutParameter.length \u003E 2 ? queryWithoutParameter  + '&' : '?') + (value ? param + \"=\" + value : '');\n                        }\n\n                        function appendMessageToLinks() {\n                            var message = \"Пожалуйста, не удаляйте это сообщение. Номер нужен для быстрого поиска Вашего обращения. Заявка № {roistat_visit}\";\n                            var text = message.replace(\u002F{roistat_visit}\u002Fg, window.roistatGetCookie('roistat_visit'));\n                            text = encodeURI(text);\n                            var linkElements = document.querySelectorAll('[href*=\"\u002F\u002Fwa.me\"], [href*=\"\u002F\u002Fapi.whatsapp.com\u002Fsend\"], [href*=\"\u002F\u002Fweb.whatsapp.com\u002Fsend\"], [href^=\"whatsapp:\u002F\u002Fsend\"]');\n                            for (var elementKey in linkElements) {\n                                if (linkElements.hasOwnProperty(elementKey)) {\n                                    var element = linkElements[elementKey];\n                                    element.href = replaceQueryParam(element.href, 'text', text);\n                                }\n                            }\n                        }\n                        if (document.readyState === 'loading') {\n                            document.addEventListener('DOMContentLoaded', init);\n                        } else {\n                            init();\n                        }\n                    };\n                })();","body":true,"type":"text\u002Fjavascript","charset":"utf-8"},{"innerHTML":"\n                    document.addEventListener('DOMContentLoaded', ()=\u003E{\n                        var waRsTimer = setInterval(function() {\n                            if (!!window.roistat && !!window.roistat.visit) {\n                                clearInterval(waRsTimer);\n                                const div = document.querySelector(\"#app \u003E div.support-widget \u003E div\")\n                                if (div){\n                                    div.onclick = function() {\n                                        setTimeout(function() {\n                                            window.onRoistatAllModulesLoaded();\n                                        }, 100);\n                                    };\n                                }\n                            }\n                        }, 500);\n                    });\n                ","body":true,"type":"text\u002Fjavascript","charset":"utf-8"},{"innerHTML":"\n                \u002F\u002F Hawk - отслеживание ошибок (загружается до Nuxt, работает независимо)\n                (function() {\n                    var HAWK_TOKEN = 'eyJpbnRlZ3JhdGlvbklkIjoiZjFiMTVlNjItNDkyMy00ODNlLWFkOTItYzZiNGUyMTc2ZTg1Iiwic2VjcmV0IjoiZjc3MzA4MWItMGQ1Ni00ODVlLTkzZGYtZWVmYTUxZTI1MDAyIn0=';\n                    if (!HAWK_TOKEN) return;\n\n                    var script = document.createElement('script');\n                    script.src = 'https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@hawk.so\u002Fjavascript@latest\u002Fdist\u002Fhawk.min.js';\n                    script.async = true;\n                    script.onload = function() {\n                        \u002F\u002F Инициализация Hawk\n                        window.hawk = new window.HawkCatcher({\n                            token: HAWK_TOKEN,\n                            consoleTracking: true,\n                            beforeSend: function(event) {\n                                \u002F\u002F Фильтруем шум\n                                if (event.title === 'Script error.' || event.title === 'Script Error') {\n                                    return false;\n                                }\n                                if (event.payload && event.payload.context && event.payload.context.url) {\n                                   var url = event.payload.context.url;\n\n                                    \u002F\u002F Расширения браузера\n                                    if (url.indexOf('chrome-extension:\u002F\u002F') !== -1) return false;\n                                    if (url.indexOf('moz-extension:\u002F\u002F') !== -1) return false;\n\n                                    \u002F\u002F Аналитика\n                                    if (url.indexOf('googletagmanager') !== -1) return false;\n                                    if (url.indexOf('google-analytics') !== -1) return false;\n                                }\n\n                                \u002F\u002F Игнорируем ошибки загрузки сторонних скриптов\n                                if (event.title === 'Resource failed to load: script') {\n                                    return false;\n                                }\n\n                                \u002F\u002F Игнорируем Permissions API ошибки (расширения\u002Fiframe)\n                                if (event.title && event.title.indexOf(\"Failed to execute 'query' on 'Permissions'\") !== -1) {\n                                    return false;\n                                }\n                                \u002F\u002F Фильтр по stack trace — SPA tracking initiator\n                                if (event.payload && event.payload.backtrace) {\n                                    var backtrace = event.payload.backtrace;\n                                    for (var i = 0; i \u003C backtrace.length; i++) {\n                                        if (backtrace[i].file && backtrace[i].file.indexOf('runSPATrackingIniciator') !== -1) {\n                                        return false;\n                                        }\n                                    }\n                                }\n                                return event;\n                            }\n                        });\n\n                        window.$hawk = window.hawk;\n\n                        \u002F\u002F Отслеживание ошибок загрузки ресурсов\n                        window.addEventListener('error', function(event) {\n                            if (event.target && event.target !== window) {\n                                var tagName = event.target.tagName ? event.target.tagName.toLowerCase() : '';\n                                if (tagName === 'script' || tagName === 'link') {\n                                    var src = event.target.src || event.target.href;\n                                    if (!src.includes('google-analytics') || event.target.id !== 'tmr-code'){\n                                        window.hawk.send(new Error('Resource failed to load: ' + tagName), {\n                                            resource: { tagName: tagName, src: src, type: event.target.type || '' },\n                                            page: window.location.href,\n                                            userAgent: navigator.userAgent\n                                        });\n                                    }\n                                }\n                            }\n                        }, true);\n\n                        \u002F\u002F Обновляем пользователя когда Nuxt загрузится\n                        function updateUser() {\n                            try {\n                                if (window.$nuxt && window.$nuxt.$store && window.$nuxt.$store.$auth) {\n                                    var auth = window.$nuxt.$store.$auth;\n                                    var user = auth.loggedIn ? auth.$state.user : null;\n                                    if (user) {\n                                        window.hawk.context = window.hawk.context || {};\n                                        window.hawk.context.user = {\n                                            id: user.id ? String(user.id) : 'unknown',\n                                            name: user.name || user.first_name || user.last_name || (user.email ? user.email.split('@')[0] : ''),\n                                            email: user.email || undefined\n                                        };\n                                    } else {\n                                        if (window.hawk.context) {\n                                            delete window.hawk.context.user;\n                                        }\n                                    }\n                                }\n                            } catch(e) {}\n                        }\n\n                        \u002F\u002F Проверяем авторизацию каждые 5 секунд\n                        setInterval(updateUser, 5000);\n                        setTimeout(updateUser, 1000);\n                    };\n                    document.head.appendChild(script);\n                })();","type":"text\u002Fjavascript","charset":"utf-8"}],"__dangerouslyDisableSanitizers":["script","innerHTML"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_clipboard_7bd1d370 === 'function') {
    await nuxt_plugin_clipboard_7bd1d370(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libplugin484ad81c_325ce1f5 === 'function') {
    await nuxt_plugin_libplugin484ad81c_325ce1f5(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_778d35d6 === 'function') {
    await nuxt_plugin_vlazyload_778d35d6(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_70df7ff4 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_70df7ff4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7d003230 === 'function') {
    await nuxt_plugin_axios_7d003230(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_5b48f8de === 'function') {
    await nuxt_plugin_pluginrouting_5b48f8de(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6997cf51 === 'function') {
    await nuxt_plugin_pluginmain_6997cf51(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin3cadf840_5758c74b === 'function') {
    await nuxt_plugin_libplugin3cadf840_5758c74b(app.context, inject)
  }

  if (typeof nuxt_plugin_gromMethods_d89c0238 === 'function') {
    await nuxt_plugin_gromMethods_d89c0238(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_057b83b1 === 'function') {
    await nuxt_plugin_logger_057b83b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initScript_56865266 === 'function') {
    await nuxt_plugin_initScript_56865266(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_img_5d5adb6c === 'function') {
    await nuxt_plugin_img_5d5adb6c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vbodyscrolllock_0f4d282c === 'function') {
    await nuxt_plugin_vbodyscrolllock_0f4d282c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_68d2fb1c === 'function') {
    await nuxt_plugin_infiniteloading_68d2fb1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtouch_036385c5 === 'function') {
    await nuxt_plugin_vtouch_036385c5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ymapPlugin_43baa32b === 'function') {
    await nuxt_plugin_ymapPlugin_43baa32b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vClickOutside_77337246 === 'function') {
    await nuxt_plugin_vClickOutside_77337246(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedadata_a85a809a === 'function') {
    await nuxt_plugin_vuedadata_a85a809a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_commonMetrics_4317ea15 === 'function') {
    await nuxt_plugin_commonMetrics_4317ea15(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemoment_732aa8ba === 'function') {
    await nuxt_plugin_vuemoment_732aa8ba(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefilterpluralize_4a7429df === 'function') {
    await nuxt_plugin_vuefilterpluralize_4a7429df(app.context, inject)
  }

  if (typeof nuxt_plugin_vueperfectscrollbar_4f61232e === 'function') {
    await nuxt_plugin_vueperfectscrollbar_4f61232e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomecountdownclient_ad4e9730 === 'function') {
    await nuxt_plugin_vueawesomecountdownclient_ad4e9730(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiperclient_d2033868 === 'function') {
    await nuxt_plugin_swiperclient_d2033868(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_retailCRMclient_3a305a7a === 'function') {
    await nuxt_plugin_retailCRMclient_3a305a7a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesimpleportal_a4e234e6 === 'function') {
    await nuxt_plugin_vuesimpleportal_a4e234e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wishlistSync_beb52c7e === 'function') {
    await nuxt_plugin_wishlistSync_beb52c7e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_utm_339bcf02 === 'function') {
    await nuxt_plugin_utm_339bcf02(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_f4517570 === 'function') {
    await nuxt_plugin_auth_f4517570(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
